import React from "react";
import type { ReactNode } from "react";

import { Fireworks, ShinyText } from "@picklebet/ui";

export const WIN_CELEBRATION_SHINE_TIMING = {
  duration: 1.2,
  repeatDelay: 3,
} as const;

type WinCelebrationProps = {
  isEnabled: boolean;
  children: ReactNode;
};

const WinCelebration = ({ isEnabled, children }: WinCelebrationProps) => (
  <Fireworks isEnabled={isEnabled}>
    <ShinyText isEnabled={isEnabled} {...WIN_CELEBRATION_SHINE_TIMING}>
      {children}
    </ShinyText>
  </Fireworks>
);

export { WinCelebration };
